import React from 'react';
import { observer } from 'mobx-react';
import Avatar from '@material-ui/core/Avatar';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';

import SelecaoStore from '../../../stores/SelecaoStore';

import AuthenticationStore from '../../../stores/AuthenticationStore';

class Cadeiras extends React.Component {
  state = { cadeira: null };

  componentWillMount() {
    SelecaoStore.candidato = null;
  }

  selecionarCandidato = cadeira => {
    SelecaoStore.selecionarCandidato(cadeira.coligacao, cadeira.posicao);
    this.setState({ cadeira });
  };

  render() {
    let cargo = AuthenticationStore.me.pesquisa.cargos.filter(
      c => c.cargo.id === AuthenticationStore.me.cargo.id
    )[0];
    let coligacoes = SelecaoStore.coligacoes;
    let cadeiras = [].concat.apply(
      [],
      coligacoes.map(c =>
        [...Array(c.vagasDiretas + c.vagasSobras).keys()].map(pos => {
          return { posicao: pos, coligacao: c.coligacao };
        })
      )
    );

    let linhas = Math.round(cargo.vagas / 10);
    let soltos = cargo.vagas - linhas * 10;

    return (
      <div {...this.props}>
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            padding: '16px',
          }}
        >
          {[...Array(10).keys()].map(x => (
            <div key={x}>
              {[...Array(linhas).keys()].map(y => (
                <div
                  style={{
                    cursor: 'pointer',
                    width: '24px',
                    height: '24px',
                    backgroundColor:
                      cadeiras.length > x * linhas + y
                        ? cadeiras[x * linhas + y].coligacao.cor
                        : 'grey',
                    borderRadius: '5px',
                    margin: '5px',
                    border:
                      cadeiras[x * linhas + y] === this.state.cadeira
                        ? '1px solid black'
                        : 'none',
                  }}
                  key={y}
                />
              ))}
            </div>
          ))}
          {soltos > 0 ? (
            <div key={10}>
              {[...Array(soltos).keys()].map(y => (
                <div
                  style={{
                    cursor: 'pointer',
                    width: '24px',
                    height: '24px',
                    backgroundColor:
                      cadeiras.length > 10 * linhas + y
                        ? cadeiras[10 * linhas + y].coligacao.cor
                        : 'grey',
                    borderRadius: '5px',
                    margin: '5px',
                    border:
                      cadeiras[10 * linhas + y] === this.state.cadeira
                        ? '1px solid black'
                        : 'none',
                  }}
                  key={y}
                />
              ))}
            </div>
          ) : (
            ''
          )}
        </div>
        {SelecaoStore.candidato ? (
          <Card style={{ margin: '16px' }}>
            <CardHeader
              avatar={
                <Avatar
                  style={{
                    backgroundColor:
                      SelecaoStore.candidato.candidato.partido.cor,
                    width: '64px',
                    height: '64px',
                  }}
                >
                  {SelecaoStore.candidato.candidato.partido.sigla}
                </Avatar>
              }
              title={SelecaoStore.candidato.candidato.nome}
              subheader={
                'Votos: ' + SelecaoStore.candidato.projecao.formatInteger()
              }
            />
          </Card>
        ) : (
          ''
        )}
      </div>
    );
  }
}

export default observer(Cadeiras);



// WEBPACK FOOTER //
// ./src/components/proporcional/vagas/Cadeiras.js